import React from 'react';
import { Package, Tag, AlertCircle } from 'lucide-react';

const BusinessProductsSection = ({ products, businessProductContext }) => {
  // Alias context for easier usage
  const businessProduct = businessProductContext;

  return (
    <div className="bg-white rounded-2xl shadow-xl border border-orange-200 p-6">
      <div className="flex items-center gap-2 mb-6">
        <Package className="h-5 w-5 text-orange-500" />
        <h3 className="text-xl font-semibold text-gray-800">
          Productos Registrados
        </h3>
      </div>

      {products && products.length > 0 ? (
        <div className="space-y-4">
          {products.map((product) => {
            // Safe navigation for formatting helper
            const formatted = businessProduct?.formatProductData 
              ? businessProduct.formatProductData(product) 
              : { formattedPrice: `$${product.product_price || '0.00'}` };

            return (
              <div 
                key={product.id || product.product_id} 
                className="border border-gray-200 rounded-lg p-4 hover:bg-orange-50 transition-colors duration-200"
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1 pr-4">
                    <div className="flex items-center gap-2 mb-1">
                      <h4 className="font-medium text-gray-800 text-lg">
                        {product.product_item}
                      </h4>
                      {product.product_category && (
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
                          <Tag className="mr-1 h-3 w-3" />
                          {product.product_category}
                        </span>
                      )}
                    </div>
                    
                    <p className="text-sm text-gray-600 mb-2">
                      {product.product_description || 'Sin descripción disponible.'}
                    </p>
                    
                    <div className="flex items-center gap-4 text-sm">
                      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                        product.product_status === 'active' 
                          ? 'bg-green-100 text-green-800' 
                          : 'bg-gray-100 text-gray-800'
                      }`}>
                        {product.product_status === 'active' ? 'Activo' : 'Inactivo'}
                      </span>
                      
                      {product.product_stock_quantity !== undefined && (
                        <span className="text-gray-500">
                          Stock: {product.product_stock_quantity}
                        </span>
                      )}
                    </div>
                  </div>
                  
                  <div className="flex flex-col items-end">
                    <span className="text-xl font-bold text-orange-600">
                      {formatted.formattedPrice}
                    </span>
                    {product.product_cost && (
                       <span className="text-xs text-gray-400 mt-1">
                         Costo: ${parseFloat(product.product_cost).toFixed(2)}
                       </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-12 bg-gray-50 rounded-lg border border-dashed border-gray-300">
          <Package className="h-12 w-12 text-gray-300 mx-auto mb-3" />
          <h4 className="text-lg font-medium text-gray-700">No hay productos registrados</h4>
          <p className="text-gray-500 text-sm mt-1">
            Este negocio aún no tiene productos en su inventario.
          </p>
        </div>
      )}
    </div>
  );
};

export default BusinessProductsSection;